import { render, staticRenderFns } from "./ScheduledMassMessageStatView.vue?vue&type=template&id=179eb63c&scoped=true&"
import script from "./ScheduledMassMessageStatView.vue?vue&type=script&lang=ts&"
export * from "./ScheduledMassMessageStatView.vue?vue&type=script&lang=ts&"
import style0 from "./ScheduledMassMessageStatView.vue?vue&type=style&index=0&id=179eb63c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179eb63c",
  null
  
)

export default component.exports